// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { addQueryParametersToUrl } from "@lg/shared";
import { ScreenDefinition } from "@lg/shared";
import { MatchTransactions } from "../../Screen/Toolbox/MatchTransactions.js";
import { ManageMetadata } from "../../Screen/Toolbox/ManageMetadata.js";
import { MainLayoutSidebar } from "../../Screen/Toolbox/MainLayoutSidebar.js";
import { MainLayoutHeader } from "../../Screen/Toolbox/MainLayoutHeader.js";
import { Login } from "../../Screen/Toolbox/Login.js";
import { Home } from "../../Screen/Toolbox/Home.js";
import { GoalSettingsMyTeam } from "../../Screen/Toolbox/GoalSettingsMyTeam.js";
import { GoalSettingsMine } from "../../Screen/Toolbox/GoalSettingsMine.js";
import { GoalSettingsListInclude } from "../../Screen/Toolbox/GoalSettingsListInclude.js";
import { GoalSettingsAll } from "../../Screen/Toolbox/GoalSettingsAll.js";
import { GoalSettingView } from "../../Screen/Toolbox/GoalSettingView.js";
import { GoalSettingGoalsInclude } from "../../Screen/Toolbox/GoalSettingGoalsInclude.js";
import { GoalSettingGoalInclude } from "../../Screen/Toolbox/GoalSettingGoalInclude.js";
import { CompanyNameLookup } from "../../Screen/Toolbox/CompanyNameLookup.js";
import { ActivityTemplate } from "../../Screen/Toolbox/ActivityTemplate.js";
import { GoalSettingSelfReviewAnswersInclude } from "../../Screen/Toolbox/GoalSettingSelfReviewAnswersInclude.js";
import { GoalSettingViewInclude } from "../../Screen/Toolbox/GoalSettingViewInclude.js";
import { GoalSettingInclude } from "../../Screen/Toolbox/GoalSettingInclude.js";
import { MainLayout } from "../../Screen/Toolbox/MainLayout.js";
import { GoalSettingHome } from "../../Screen/Toolbox/GoalSettingHome.js";
import { GoalSettingEdit } from "../../Screen/Toolbox/GoalSettingEdit.js";
import { GoalSettingsPerCycle } from "../../Screen/Toolbox/GoalSettingsPerCycle.js";
import { FrontendScreenBridge } from "@lg/ng-shared";

export const $Screens = {
    MatchTransactions: {
        moduleId: 'Toolbox', boId: 'MatchTransactions', component: MatchTransactions, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/MatchTransactions', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    ManageMetadata: {
        moduleId: 'Toolbox', boId: 'ManageMetadata', component: ManageMetadata, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/ManageMetadata', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MainLayoutSidebar: {
        moduleId: 'Toolbox', boId: 'MainLayoutSidebar', component: MainLayoutSidebar, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/MainLayoutSidebar', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MainLayoutHeader: {
        moduleId: 'Toolbox', boId: 'MainLayoutHeader', component: MainLayoutHeader, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/MainLayoutHeader', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    Login: {
        moduleId: 'Toolbox', boId: 'Login', component: Login, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/Login', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        redirect: string,
    }, {
        }>,
    Home: {
        moduleId: 'Toolbox', boId: 'Home', component: Home, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/Home', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    GoalSettingsMyTeam: {
        moduleId: 'Toolbox', boId: 'GoalSettingsMyTeam', component: GoalSettingsMyTeam, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingsMyTeam', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    GoalSettingsMine: {
        moduleId: 'Toolbox', boId: 'GoalSettingsMine', component: GoalSettingsMine, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingsMine', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    GoalSettingsListInclude: {
        moduleId: 'Toolbox', boId: 'GoalSettingsListInclude', component: GoalSettingsListInclude, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingsListInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        additionalFilterOptions: Partial<Sys.Types.FindOptionsWhere<This.GoalSetting>>,
        linkToScreen?: 'Edit' | 'View',
    }, {
        }>,
    GoalSettingsAll: {
        moduleId: 'Toolbox', boId: 'GoalSettingsAll', component: GoalSettingsAll, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingsAll', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    GoalSettingView: {
        moduleId: 'Toolbox', boId: 'GoalSettingView', component: GoalSettingView, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingView', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
        id: This.GoalSetting.Id,
    }, {
        }, {
        }>,
    GoalSettingGoalsInclude: {
        moduleId: 'Toolbox', boId: 'GoalSettingGoalsInclude', component: GoalSettingGoalsInclude, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingGoalsInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        gs: This.GoalSetting,
        goals: This.GoalSettingGoal[],
        goalType: This.GoalSettingGoalType,
        viewMode: This.GoalSettingViewMode,
        columnVisibility: This.GoalSettingGoalColumnVisibility,
        validateMinGoals?: number,
    }, {
        }>,
    GoalSettingGoalInclude: {
        moduleId: 'Toolbox', boId: 'GoalSettingGoalInclude', component: GoalSettingGoalInclude, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingGoalInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        gs: This.GoalSetting,
        goal: This.GoalSettingGoal,
        viewMode: This.GoalSettingViewMode,
        columnVisibility: This.GoalSettingGoalColumnVisibility,
    }, {
        }>,
    CompanyNameLookup: {
        moduleId: 'Toolbox', boId: 'CompanyNameLookup', component: CompanyNameLookup, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/CompanyNameLookup', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    ActivityTemplate: {
        moduleId: 'Toolbox', boId: 'ActivityTemplate', component: ActivityTemplate, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/ActivityTemplate', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    GoalSettingSelfReviewAnswersInclude: {
        moduleId: 'Toolbox', boId: 'GoalSettingSelfReviewAnswersInclude', component: GoalSettingSelfReviewAnswersInclude, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingSelfReviewAnswersInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        gs: This.GoalSetting,
        viewMode: This.GoalSettingViewMode,
        columnVisibility: This.GoalSettingGoalColumnVisibility,
    }, {
        }>,
    GoalSettingViewInclude: {
        moduleId: 'Toolbox', boId: 'GoalSettingViewInclude', component: GoalSettingViewInclude, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingViewInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        gs: This.GoalSetting,
        viewMode: This.GoalSettingViewMode,
    }, {
        }>,
    GoalSettingInclude: {
        moduleId: 'Toolbox', boId: 'GoalSettingInclude', component: GoalSettingInclude, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        gs: This.GoalSetting,
        viewMode: This.GoalSettingViewMode,
        columnVisibility: This.GoalSettingGoalColumnVisibility,
    }, {
        }>,
    MainLayout: {
        moduleId: 'Toolbox', boId: 'MainLayout', component: MainLayout, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/MainLayout', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        screenTitle?: string,
        isForExternalUser?: boolean,
    }, {
        }>,
    GoalSettingHome: {
        moduleId: 'Toolbox', boId: 'GoalSettingHome', component: GoalSettingHome, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingHome', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    GoalSettingEdit: {
        moduleId: 'Toolbox', boId: 'GoalSettingEdit', component: GoalSettingEdit, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingEdit', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
        id: This.GoalSetting.Id,
    }, {
        }, {
        }>,
    GoalSettingsPerCycle: {
        moduleId: 'Toolbox', boId: 'GoalSettingsPerCycle', component: GoalSettingsPerCycle, getFullUrl(params) {
            return addQueryParametersToUrl('/Toolbox/GoalSettingsPerCycle', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
};
